import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import {Carousel} from 'react-responsive-carousel';

let CarouselSettings = {
    showStatus: false,
    showThumbs: false,
    showIndicators: true,
    infiniteLoop: true,
    swipeable: true,
    showArrows: false,
    autoPlay: true,
    interval: 8000,
};

const Slider = ({ values }) => (
    <Carousel {...CarouselSettings}>
        {values.map((value, index) => (
            <div
                key={`figure${index}`}
                dangerouslySetInnerHTML={{
                    __html: value.html,
                }}
            ></div>
        ))}
    </Carousel>
);

export default Slider;
